module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("Тарифные планы "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'rate-plan-add'
      }
    }
  }, [_vm._v("+ Добавить тарифный план")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_vm._v("← Назад к Настройкам")])], 1), _vm._v(" "), _c('resource-list', {
    attrs: {
      "url": "/rate-plans",
      "current-sort": "name",
      "resource-name": "rate-plans",
      "action-routes": _vm.actionRoutes,
      "fields": _vm.fields,
      "filters": _vm.filters
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40d6ad3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rate_plan/RatePlans.vue
// module id = 628
// module chunks = 0